export default (set, get, segments) => set(
  () => ({
    compatibilitySegments: segments
  }),
  false,
  { type: 'updateCompatibilitySegments', payload: Object.keys(segments) }
);
